/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { PatientPortalMessageTypesData, PracticeMessageTypesData } from '../model/patientPortalMessageTypesData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class GetPatientPortalMessageTypesService {

    protected basePath = environment.appSetting.apiUrl+'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.GetPatientPortalMessageTypes
     * This API get PatientPortalMessageTypes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPatientPortalMessageTypes(observe?: 'body', reportProgress?: boolean): Observable<Array<PatientPortalMessageTypesData>>;
    public getPatientPortalMessageTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PatientPortalMessageTypesData>>>;
    public getPatientPortalMessageTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PatientPortalMessageTypesData>>>;
    public getPatientPortalMessageTypes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Array<PatientPortalMessageTypesData>>(`${this.basePath}/GetPatientPortalMessageTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


      public getPracticeMessageTypes(status: number, observe?: 'body', reportProgress?: boolean): Observable<Array<PracticeMessageTypesData>>;
    public getPracticeMessageTypes(status: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PracticeMessageTypesData>>>;
    public getPracticeMessageTypes(status: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PracticeMessageTypesData>>>;
    public getPracticeMessageTypes(status: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
         
        // to determine the Accept header
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Array<PatientPortalMessageTypesData>>(`${this.basePath}/GetMessageTypesLookupLoader`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


}
